import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
// import ExportsList from "../components/DownloadContestPaper/ExportsList";
import NewExportForm from "../components/DownloadContestPaper/NewExportForm";
// import ExportConfiguration from "../components/DownloadContestPaper/ExportConfiguration";
// import { isAdmin } from "../functions/checkrole";

/*
 * TODO: Re-enable when backend exists for list + admin configuration.
 * Tabs were: Exports | New Export | Configuration (admin).
 *
 * import { Box, Grid, Tab, Tabs } from "@mui/material";
 * const tabContainerStyle = { margin: "30px 42px 0 42px", borderBottom: "1px solid #E0E0E0" };
 * const tabStyle = (active) => ({ ... });
 *
 * const [tab, setTab] = useState(0);
 * const [refreshKey, setRefreshKey] = useState(0);
 * const triggerRefresh = () => setRefreshKey((k) => k + 1);
 * const showAdminTab = isAdmin();
 *
 * <div style={tabContainerStyle}>
 *   <Tabs value={tab} onChange={(_, v) => setTab(v)} TabIndicatorProps={{ style: { backgroundColor: "#144A94" } }}>
 *     <Tab style={tabStyle(tab === 0)} label="Exports" />
 *     <Tab style={tabStyle(tab === 1)} label="New Export" />
 *     {showAdminTab && <Tab style={tabStyle(tab === 2)} label="Configuration" />}
 *   </Tabs>
 * </div>
 * <Box style={{ paddingInline: 42, marginTop: 24 }}>
 *   {tab === 0 && <ExportsList key={refreshKey} />}
 *   {tab === 1 && <NewExportForm setLoading={setLoading} onCreated={() => { triggerRefresh(); setTab(0); }} />}
 *   {tab === 2 && showAdminTab && <ExportConfiguration setLoading={setLoading} />}
 * </Box>
 */

export default function DownloadContestPaper() {
  document.title = "Download Contest Paper";

  const [loading, setLoading] = useState(false);

  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />

      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <div className="dashboardAndSelfBtnDiv">
          <ReusableButton
            text="Dashboard"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            width={125}
            br={18}
            to="/dashboard"
            iconType="home"
          />
          <ChevronRightIcon />
          <ReusableButton
            text="Download Contest Paper"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            br={18}
          />
        </div>
      </Grid>

      <Grid className="tableContainer" container>
        <NunitoText
          value="Download Contest Paper"
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
        />
      </Grid>

      <Box style={{ paddingInline: 42, marginTop: 24 }}>
        <NewExportForm setLoading={setLoading} />
      </Box>
    </Box>
  );
}
